var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.reverseAwards(_vm.projectAwards, true)),function(award,index){return _c('div',{key:award.id,class:{
         'award_isef': _vm.$isIsef,
         'award_submission' : _vm.isSubmission || _vm.isMyProject,
         'award_isef_viewAll': _vm.isViewAll
       },style:({'z-index': (index + 5),
        'left': _vm.spaceBetweenAwards * (_vm.reverseAwards(_vm.projectAwards, true).length - 1.5 - index) + 'px'}),attrs:{"data-balloon":_vm.$t(award.name),"data-balloon-pos":"up-right"}},[(award.showRibbon)?_c('img',{attrs:{"src":award.image,"alt":_vm.$t(award.name)}}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }